export default __webpack_public_path__ + "assets/wizard-grid-75e715c3a0a03a34520bbd6ff1de2670.svg";